import React from 'react'
import PropTypes from 'prop-types'

import styles from './../style/Cards1.module.scss'

import { Container, Image } from 'react-bootstrap'

import WhiteBlockTitle from './WhiteBlockTitle'
import GreenButton from './GreenButton'
import FeedbackForm from './FeedbackForm'
import ClientOnlyFsLightbox from './ClientOnlyFsLightbox'

class Cards1 extends React.Component {
  
  constructor(props) {
    super(props)

    this.state = {
      show_feedback: false,
      feedback_title: ``,
      feedback_name: ``,
      lightboxController: {
        toggler: false,
        slide: 1
      },
      lightboxSources: []
    }
  }

  showFeedback = ( title, name ) => {
    this.setState({ show_feedback: true, feedback_title: title, feedback_name: name });
  }
  
  closeFeedback = () => {
    this.setState({ show_feedback: false });
  }

  openLightbox = (index, imageSrc) => {
    // Собираем все полноразмерные изображения для lightbox
    const fullImages = this.props.list
      .filter(item => item.full || item.image || item.fon)
      .map(item => item.full || item.image || item.fon);
    
    // Находим индекс текущего изображения в массиве fullImages
    const slideIndex = fullImages.findIndex(src => src === imageSrc) + 1;
    
    this.setState({
      lightboxController: {
        toggler: !this.state.lightboxController.toggler,
        slide: slideIndex
      },
      lightboxSources: fullImages
    });
  }

  formatSlideNumber = (index) => {
    // Добавляем ведущий ноль для чисел меньше 10
    return `[${index < 9 ? '0' + (index + 1) : index + 1}]`
  }

  render() {

    const { list, title, text, rtext, margin, cols, bg, layout, imageSize, button } = this.props,
    { show_feedback, feedback_title, feedback_name, lightboxController, lightboxSources } = this.state

    return (
      <section className={`${styles.section} ${styles[margin]}`}>
        <Container>
          {title != `` &&
            <WhiteBlockTitle
              title={title}
              text={rtext}
              className={styles.title}
            />
          }
          {text != `` &&
            <div className={styles.text} dangerouslySetInnerHTML={{__html: text}} />
          }
          
          {/* Lightbox компонент */}
          <ClientOnlyFsLightbox
            toggler={lightboxController.toggler}
            sources={lightboxSources}
            slide={lightboxController.slide}
          />

          <div className={`${styles.list} ${styles[`grid-${cols}`]}`}>
            {list.map( ( elm, k ) => {
              if(layout == 2) return (
                <div className={`${styles.block} ${styles[`bg-${bg}`]}`}>
                  <div className={styles.b_title_2}>
                    {elm?.icon != `` &&
                      <div className={styles.b_icon}>
                        <Image src={elm?.icon} width={21} height={21} alt={elm?.name} />
                      </div>
                    }
                    <div className={styles.b_title_sep} />
                    <div>{this.formatSlideNumber(k)}</div>
                  </div>
                  <div className={styles.b_title_t_2} dangerouslySetInnerHTML={{__html: elm?.name}} />
                  <div className={styles.b_text} dangerouslySetInnerHTML={{__html: elm?.text}} />
                </div>
              )
              if(layout == 3) return (
                <div className={`${styles.block} ${styles[`bg-${bg}`]}`}>
                  <div className={styles.b_title}>
                    <div className={styles.b_title_block}>
                      <div className={styles.b_icon}>
                        <Image src={elm?.icon} width={21} height={21} alt={elm?.name} />
                      </div>
                      <div className={styles.b_title_t} dangerouslySetInnerHTML={{__html: elm?.name}} />
                    </div>
                    <div>{this.formatSlideNumber(k)}</div>
                  </div>
                  <div className={styles.b_text} dangerouslySetInnerHTML={{__html: elm?.text}} />
                </div>
              )
              if(layout == 4) return (
                <div className={`${styles.block} ${styles[`bg-${bg}`]}`}>
                  <div className={styles.b_title}>
                    <div className={styles.b_title_t} dangerouslySetInnerHTML={{__html: elm?.name}} />
                    <div>{this.formatSlideNumber(k)}</div>
                  </div>
                  <div className={styles.b_text} dangerouslySetInnerHTML={{__html: elm?.text}} />
                  {elm?.image &&
                    <Image 
                      className={styles.b_botimg} 
                      src={elm?.image} 
                      alt={elm?.name}
                      onClick={() => this.openLightbox(k, elm?.full || elm?.image)}
                      style={{cursor: 'pointer'}}
                    />
                  }
                  <div className={styles.block_osadabottom}>
                    {elm?.icon &&
                      <div className={styles.b_icon}>
                        <Image src={elm?.icon} width={21} height={21} alt={`и-${k}`} />
                      </div>
                    }
                    <div className={styles.block_osadabottom_text} dangerouslySetInnerHTML={{__html: elm?.text2}} />
                    <GreenButton
                      text={`Рассчитать стоимость`}
                      width={174}
                      className={styles.b_osadabottom_btn}
                      action={() => { this.showFeedback( `Рассчитать стоимость`, elm?.name ) }}
                    />
                  </div>
                </div>
              )
              if(layout == 5) return (
                <div className={`${styles.block} ${styles[`bg-${bg}`]}`}>
                  {elm?.image &&
                    <Image 
                      className={styles.b_topimg} 
                      src={elm?.image} 
                      width={imageSize?.width} 
                      height={imageSize?.height} 
                      alt={elm?.name}
                      onClick={() => this.openLightbox(k, elm?.full || elm?.image)}
                      style={{cursor: 'pointer'}}
                    />
                  }
                  <div className={styles.b_title}>
                    <div className={styles.b_title_t} dangerouslySetInnerHTML={{__html: elm?.name}} />
                    <div>{this.formatSlideNumber(k)}</div>
                  </div>
                  <div className={styles.b_text} dangerouslySetInnerHTML={{__html: elm?.text}} />
                  <GreenButton
                    text={`Рассчитать стоимость`}
                    width={0}
                    className={styles.b_btn_fw}
                    action={() => { this.showFeedback( `Рассчитать стоимость`, elm?.name ) }}
                  />
                </div>
              )
              if(layout == 6) return (
                <div className={`${styles.block} ${styles[`bg-${bg}`]} ${styles.block_rimg}`}>
                  <div className={styles.b_title}>
                    <div className={styles.b_title_t} dangerouslySetInnerHTML={{__html: elm?.name}} />
                    <div>{this.formatSlideNumber(k)}</div>
                  </div>
                  <div className={styles.b_text} dangerouslySetInnerHTML={{__html: elm?.text}} />
                  {elm?.image &&
                    <Image 
                      className={styles.b_rightimg} 
                      src={elm?.image} 
                      width={173} 
                      height={180} 
                      alt={elm?.name}
                      onClick={() => this.openLightbox(k, elm?.full || elm?.image)}
                      style={{cursor: 'pointer'}}
                    />
                  }
                </div>
              )
              if(layout == 7) return (
                <div className={`${styles.block} ${styles[`bg-${bg}`]} ${styles.block_rimg_big}`}>
                  <div className={styles.b_title}>
                    <div>[GOOWDIN]</div>
                    <div>{this.formatSlideNumber(k)}</div>
                  </div>
                  <div className={styles.block_rimg_big_title}>
                    <div className={styles.b_title_t} dangerouslySetInnerHTML={{__html: elm?.name}} />
                    <GreenButton
                      text={`Подробнее`}
                      width={142}
                      addClass={`white`}
                      action={() => { this.showFeedback( `Подробнее`, elm?.name ) }}
                    />
                  </div>
                  {elm?.image &&
                    <Image 
                      className={styles.b_rightimg_big} 
                      src={elm?.image} 
                      height={165} 
                      alt={elm?.name}
                      onClick={() => this.openLightbox(k, elm?.full || elm?.image)}
                      style={{cursor: 'pointer'}}
                    />
                  }
                </div>
              )
              if(layout == 8) return (
                <div className={`${styles.block} ${styles[`bg-${bg}`]} ${styles.block_rimg2}`}>
                  <div className={styles.block_rimg2_content}>
                    <div className={styles.block_rimg2_left}>
                      {elm?.image &&
                        <Image 
                          src={elm?.image} 
                          height={165} 
                          alt={elm?.name}
                          onClick={() => this.openLightbox(k, elm?.full || elm?.image)}
                          style={{cursor: 'pointer'}}
                        />
                      }
                      <div className={styles.block_rimg2_left_title}>
                        <div>[GOOWDIN]</div>
                        <div className={styles.block_rimg2_left_title_sep} />
                        <div>{this.formatSlideNumber(k)}</div>
                      </div>
                    </div>
                    <div className={styles.block_rimg2_center}>
                      <div className={styles.block_rimg2_center_title} dangerouslySetInnerHTML={{__html: elm?.title}} />
                      <div className={styles.block_rimg2_center_card}>
                        <div>
                          В случае каких-либо вопросов или замечании можете написать лично мне на e-mail
                        </div>
                        <div className={styles.block_rimg2_center_card_sep} />
                        <div>
                          <div className={styles.block_rimg2_center_card_email}>
                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M12.75 15.375H5.25C3 15.375 1.5 14.25 1.5 11.625V6.375C1.5 3.75 3 2.625 5.25 2.625H12.75C15 2.625 16.5 3.75 16.5 6.375V11.625C16.5 14.25 15 15.375 12.75 15.375Z" stroke="black" stroke-width="1.25" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M12.75 6.75L10.4025 8.625C9.63 9.24 8.3625 9.24 7.59 8.625L5.25 6.75" stroke="black" stroke-width="1.25" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            <div>{elm?.mail}</div>
                          </div>
                          <div>Написать на почту</div>
                        </div>
                      </div>
                      <div className={styles.block_rimg2_center_bottom}>
                        <div>
                          <div>{elm?.dolznost}</div>
                          <div className={styles.block_rimg2_center_bottom_name}>{elm?.name}</div>
                        </div>
                        <GreenButton
                          svg={(
                            <Image src={`/IOJKDfb_assets/images/vk.svg`} alt="vk" width={15} height={15} />
                          )}
                          text={`Подписаться`}
                          width={123}
                          addClass={`white`}
                          href={`https://vk.com/goodwin_nnov`}
                        />
                      </div>
                    </div>
                  </div>
                  {elm?.image2 &&
                    <Image 
                      className={styles.block_rimg2_right} 
                      src={elm?.image2} 
                      height={271} 
                      alt={elm?.title}
                    />
                  }
                </div>
              )
              if(layout == 9) {
                if(elm?.image != ``) return (
                  <div className={`${styles.block} ${styles[`bg-2`]} ${styles.block_restovr}`}>
                    <div className={styles.block_restovr_content}>
                      <div className={styles.b_title_2}>
                        <div className={styles.b_icon}>
                          <Image src={elm?.icon} width={21} height={21} alt={elm?.name} />
                        </div>
                        <div className={styles.b_title_sep} />
                        <div>{this.formatSlideNumber(k)}</div>
                      </div>
                      <div className={styles.b_title_t_2} dangerouslySetInnerHTML={{__html: elm?.name}} />
                    </div>
                    {elm?.image &&
                      <div className={styles.block_restovr_rimg}>
                        <Image 
                          src={elm?.image} 
                          height={119} 
                          alt={elm?.title}
                          onClick={() => this.openLightbox(k, elm?.full || elm?.image)}
                          style={{cursor: 'pointer'}}
                        />
                      </div>
                    }
                  </div>
                )
                return (
                  <div className={`${styles.block} ${styles[`bg-1`]} ${styles.block_restovr_s}`}>
                    <div className={styles.b_title_2}>
                      <div className={styles.b_icon}>
                        <Image src={elm?.icon} width={21} height={21} alt={elm?.name} />
                      </div>
                      <div className={styles.b_title_sep} />
                      <div>{this.formatSlideNumber(k)}</div>
                    </div>
                    <div className={styles.b_title_t_2} dangerouslySetInnerHTML={{__html: elm?.name}} />
                  </div>
                )
              }
              if(layout == 10) {
                return (
                  <div className={`${styles.block} ${styles[`bg-${bg}`]} ${styles[`h-auto`]}`}>
                    <div className={styles.b_title_2}>
                      <div className={styles.b_title_t} dangerouslySetInnerHTML={{__html: elm?.name}} />
                      <div className={styles.b_title_sep} />
                      {elm?.image &&
                        <Image src={elm?.image} width={21} height={21} alt={`и-${k}`} />
                      }
                    </div>
                    <div className={styles.b_text} dangerouslySetInnerHTML={{__html: elm?.text}} />
                  </div>
                )
              }
              if(layout == 11) {
                return (
                  <div className={`${styles.block} ${styles[`bg-${bg}`]} ${styles[`h-auto`]}`}>
                    {elm?.image &&
                      <Image 
                        className={styles.b_topimg_fw} 
                        src={elm?.image} 
                        width={imageSize?.width} 
                        height={imageSize?.height} 
                        alt={elm?.name}
                        onClick={() => this.openLightbox(k, elm?.full || elm?.image)}
                        style={{cursor: 'pointer'}}
                      />
                    }
                    <div className={styles.b_title_2}>
                      <div className={styles.b_title_t} dangerouslySetInnerHTML={{__html: elm?.name}} />
                      <div className={styles.b_title_sep} />
                      <div>{this.formatSlideNumber(k)}</div>
                    </div>
                    <div className={styles.b_text} dangerouslySetInnerHTML={{__html: elm?.text}} />
                  </div>
                )
              }
              if(layout == 12) {
                return (
                  <div className={`${styles.block} ${styles.akcii}`}>
                    <Image 
                      className={styles.b_fonimg} 
                      src={elm?.fon} 
                      width={585} 
                      height={162} 
                      alt={elm?.name}
                      onClick={() => this.openLightbox(k, elm?.full || elm?.fon)}
                      style={{cursor: 'pointer'}}
                    />
                    <div className={styles.akcii_content}>
                      <div className={styles.akcii_content_lb}>
                        <div className={styles.akcii_content_title} dangerouslySetInnerHTML={{__html: elm?.name}} />
                        <div className={styles.akcii_content_text} dangerouslySetInnerHTML={{__html: elm?.text}} />
                        {button?.name != `` &&
                          <GreenButton
                            text={elm?.btn}
                            width={181}
                            className={styles.akcii_content_btn}
                            svg={(
                              <Image src={elm?.icon} alt={`и-${k}`} width={15} height={15} />
                            )}
                            action={() => { this.showFeedback( elm?.name, elm?.name ) }}
                          />
                        }
                      </div>
                      {elm?.image &&
                        <Image 
                          className={styles.akcii_content_rimg} 
                          src={elm?.image} 
                          height={156} 
                          alt={elm?.name}
                        />
                      }
                    </div>
                  </div>
                )
              }
              if(layout == 13) return (
                <div className={`${styles.block} ${styles[`bg-${bg}`]}`}>
                  <div className={styles.b_title_2}>
                    <div className={styles.b_title_t} dangerouslySetInnerHTML={{__html: elm?.name}} />
                    <div className={styles.b_title_sep} />
                    <Image src={elm?.icon} width={21} height={21} alt={elm?.name} />
                  </div>
                  <div className={styles.b_text} dangerouslySetInnerHTML={{__html: elm?.text}} />
                </div>
              )
              if(layout == 14) return (
                <>
                  <div className={`${styles.block} ${styles[`bg-1`]}`}>
                    <div className={styles.b_title_2}>
                      <div className={styles.b_icon}>
                        <Image src={elm?.icon} width={21} height={21} alt={elm?.name} />
                      </div>
                      <div className={styles.b_title_sep} />
                      <div>{this.formatSlideNumber(k)}</div>
                    </div>
                    <div className={styles.b_title_t_2} dangerouslySetInnerHTML={{__html: elm?.name}} />
                    <div className={styles.b_text} dangerouslySetInnerHTML={{__html: elm?.text}} />
                  </div>
                  <div className={`${styles.block} ${styles[`bg-2`]} ${styles.partners}`}>
                    <div>
                      <div className={styles.b_text} dangerouslySetInnerHTML={{__html: elm?.text2}} />
                      <div className={styles.partners_sep} />
                      <GreenButton
                        text={`Получить предложение`}
                        width={327}
                        className={styles.partners_btn}
                        action={() => { this.showFeedback( `Получить предложение`, elm?.name ) }}
                      />
                    </div>
                    {elm?.image &&
                      <Image 
                        className={styles.partners_imag} 
                        src={elm?.image} 
                        width={206} 
                        alt={elm?.name}
                        onClick={() => this.openLightbox(k, elm?.full || elm?.image)}
                        style={{cursor: 'pointer'}}
                      />
                    }
                  </div>
                </>
              )
              if(elm?.fon != ``) return (
                <div className={`${styles.block} ${styles.bg_image}`}>
                  <Image 
                    className={styles.b_fonimg} 
                    src={elm?.fon} 
                    width={386} 
                    height={165} 
                    alt={elm?.name}
                    onClick={() => this.openLightbox(k, elm?.full || elm?.fon)}
                    style={{cursor: 'pointer'}}
                  />
                  {elm?.icon &&
                    <div className={styles.b_icon}>
                      <Image src={elm?.icon} width={21} height={21} alt={`и-${k}`} />
                    </div>
                  }
                  <div className={styles.b_title}>
                    <div className={styles.b_title_t} dangerouslySetInnerHTML={{__html: elm?.name}} />
                    <div>{this.formatSlideNumber(k)}</div>
                  </div>
                  <div className={styles.b_text} dangerouslySetInnerHTML={{__html: elm?.text}} />
                  {button?.name != `` &&
                    <GreenButton
                      text={button?.text}
                      width={button?.width}
                      action={() => { this.showFeedback( button?.text, elm?.name ) }}
                      className={styles.b_btn}
                    />
                  }
                </div>
              )
              return (
                <div className={`${styles.block} ${styles[`bg-${bg}`]}`}>
                  {elm?.image &&
                    <Image 
                      className={styles.b_topimg} 
                      src={elm?.image} 
                      width={imageSize?.width} 
                      height={imageSize?.height} 
                      alt={elm?.name}
                      onClick={() => this.openLightbox(k, elm?.full || elm?.image)}
                      style={{cursor: 'pointer'}}
                    />
                  }
                  {elm?.icon &&
                    <div className={styles.b_icon}>
                      <Image src={elm?.icon} width={21} height={21} alt={`и-${k}`} />
                    </div>
                  }
                  <div className={styles.b_title}>
                    <div className={styles.b_title_t} dangerouslySetInnerHTML={{__html: elm?.name}} />
                    <div>{this.formatSlideNumber(k)}</div>
                  </div>
                  <div className={styles.b_text} dangerouslySetInnerHTML={{__html: elm?.text}} />
                </div>
              )
            })}
          </div>
        </Container>
        <FeedbackForm
          title={feedback_title}
          text={`Свяжитесь с нами и мы оперативно проконсультируем вас`}
          btn={`Отправить`}
          data={[
            {
              name: `Элемент`,
              value: feedback_name
            }
          ]}
          show={show_feedback}
          handleClose={() => this.closeFeedback()}
        />
      </section>
    )
  }
}

Cards1.propTypes = {
  list: PropTypes.array,
  title: PropTypes.string,
  text: PropTypes.string,
  rtext: PropTypes.string,
  margin: PropTypes.string,
  cols: PropTypes.string,
  bg: PropTypes.string,
  layout: PropTypes.number,
  imageSize: PropTypes.object,
  button: PropTypes.object
}

Cards1.defaultProps = {
  list: [],
  title: ``,
  text: ``,
  rtext: ``,
  margin: `none`,
  cols: `3`,
  bg: `1`,
  layout: 1,
  imageSize: {
    width: 346,
    height: 202
  },
  button: {
    text: ``,
    width: 0,
    action: () => {}
  }
}

export default Cards1